import React, { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'
import styled from '@emotion/styled'
import logoSrc from 'view/styles/images/brokerTecLogo.svg'
import * as mixins from 'view/styles/mixins'

interface HomeTileProps {
  showLogo?: boolean
  children?: React.ReactNode
}

const HomeTileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  width: 190px;
`

const ChildrenWrapper = styled.div`
  flex: 0;
  margin-right: 6px;
  overflow: hidden;
  ${HomeTileWrapper}:hover & {
    flex: 0 0 24px;
  }
  ${mixins.panelTransition}
`

const HomeLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 0 10px 0 0;
`

const Logo = styled.img`
  width: 125px;
`

export const HomeTile: FunctionComponent<HomeTileProps> = props => {
  return (
    <HomeTileWrapper>
      <ChildrenWrapper>{props.children}</ChildrenWrapper>
      {props.showLogo && (
        <HomeLink to={'/'}>
          <Logo alt="Logo" src={logoSrc} />
        </HomeLink>
      )}
    </HomeTileWrapper>
  )
}
